import CircularProgress from '@material-ui/core/CircularProgress';
import { Box, Typography, useMediaQuery, Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { useAppSelector } from '../reduxhooks';
import OverlayComponentChoice from './OverlayComponentChoice';
import OverlayComponentTitle from './OverlayComponentTitle';
import { useEffect } from 'react';
import React from 'react';
import { ClothingMeasurementDetailPanel, getClothingMeasurementsRuler, getClothingMeasurementsSubtext } from './OverlayViewGenerateMeasureMethod3Favorite1ModifySize';
import { CalculateClothingMeasurementsFromBodyMeasurements, ClothingType, FitType, GetKey2CategoryClothingSizeMeasurementValues, RoundClothingMeasurementsToHalfPoint } from 'common-ts/dist/models/UserMeasurements';
import { RegularSizeValue } from 'common-ts/dist/models/Cart';
import { Player } from '@lottiefiles/react-lottie-player';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
}),
);

interface Props {
  onFetchMeasEstimateSuccess: () => void
  currentFlowData: any 
  reductionMode?: boolean
}

export default function PageCheckoutMeasurements({ onFetchMeasEstimateSuccess, currentFlowData, reductionMode=false }: Props) {
  const classes = useStyles();
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("sm"));

  const [finishedLoading, setFinishedLoading] = React.useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      setFinishedLoading(true);
    }, 8200)
  }, []);

  useEffect(() => {
    if (finishedLoading) {
      setTimeout(() => {
        onFetchMeasEstimateSuccess();
      }, 400);
    }
  }, [finishedLoading]);


  if (!currentFlowData?.clothingType) {
    return null;
  }

  const key2ClothSizeValues = GetKey2CategoryClothingSizeMeasurementValues(currentFlowData.clothingType, 
    currentFlowData?.fitType, false);
  const rawClothingMeas = CalculateClothingMeasurementsFromBodyMeasurements(
    currentFlowData?.clothingType, 
    currentFlowData?.fitType,
    currentFlowData?.clothMeasValue as any, RegularSizeValue.L);
  const currentClothingMeas = RoundClothingMeasurementsToHalfPoint(rawClothingMeas);

  const subtextDict = getClothingMeasurementsSubtext(currentFlowData.clothingType, key2ClothSizeValues, currentClothingMeas);
  const sizeRulerDict = getClothingMeasurementsRuler(currentFlowData.clothingType, key2ClothSizeValues, rawClothingMeas);

  // WE USE BODY BASED RULER & SUBTEXT (THE C VALUES ARE COMPARED TO C_BODY VALUES) TO MAINTAIN CONSISTENCY
  const currentRawClothingMeasBody = CalculateClothingMeasurementsFromBodyMeasurements(ClothingType.Body, FitType.RegularFit, currentFlowData?.clothMeasValue as any, RegularSizeValue.L);
  const currentClothingMeasBody = RoundClothingMeasurementsToHalfPoint(currentRawClothingMeasBody);
  const key2ClothSizeValuesBody = GetKey2CategoryClothingSizeMeasurementValues(ClothingType.Body, FitType.RegularFit, false);
  const subtextDictBody = getClothingMeasurementsSubtext(ClothingType.Body, key2ClothSizeValuesBody, currentClothingMeasBody);
  const sizeRulerDictBody = getClothingMeasurementsRuler(ClothingType.Body, key2ClothSizeValuesBody, currentRawClothingMeasBody);

  if (isMdOrUp) {
    return (
      <Grid container>
        <Grid item xs={6}>
          <Player
            key='regular-animation'
            autoplay
            // loop
            src={'https://studiosclo.uk/general/Loading_Screen_4.json'}
            style={{
              width: '100%',
              marginLeft: '0%',
              marginTop: '-4%',
              marginBottom: '-7%',
            }}
          >
          </Player>
        </Grid>
        <Grid item xs={6} style={{paddingTop: '20vh'}}>
          <ClothingMeasurementDetailPanel
          clothingType={currentFlowData.clothingType as ClothingType}
          fitType={currentFlowData.fitType as FitType}
          allowEditing={false}
          currentClothingMeas={currentClothingMeas}
          currentClothingMeasSubtextDict={subtextDictBody}
          currentlyFetchingAvailability={false}
          isMinimized={true}
          isSizeWheel={true}
          sizeWheelDict={sizeRulerDictBody}
          reductionMode={reductionMode}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Box style={{
        padding: "0px 20px",
        // marginTop: '5em',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <Box style={{
          width: '100%',
          minHeight: '80vw',
          overflow: 'clip',
          margin: '0px 0px 0px',
        }}>
          <Player
            key='regular-animation'
            autoplay
            // loop
            src={'https://studiosclo.uk/general/Loading_Screen_4.json'}
            style={{
              width: '100%',
              marginLeft: '0%',
              marginTop: '-4%',
              marginBottom: '-7%',
            }}
          >
          </Player>
        </Box>
        <ClothingMeasurementDetailPanel
        clothingType={currentFlowData.clothingType as ClothingType}
        fitType={currentFlowData.fitType as FitType}
        allowEditing={false}
        currentClothingMeas={currentClothingMeas}
        currentClothingMeasSubtextDict={subtextDictBody}
        currentlyFetchingAvailability={false}
        isMinimized={true}
        isSizeWheel={true}
        sizeWheelDict={sizeRulerDictBody}
        reductionMode={reductionMode}
        />
      </Box>
    </>
  );
}